// The back end's process manager ids (ib `ProcessManagersEnum`). The client API
// accepts the deferred payment order or no field at all (ib 6.20.6, #804).
export enum ProcessManagerEnum {
  StandingOrder = 1,
}
